import CampusService from "@/api/services/personal/nomencladores/CampusService"
import Vue from "vue"

const state = () => ({
    campus: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "codigo",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    CAMPUS: state => {
        return state.campus
    },
    CAMPUS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_CAMPUS: (state, payload) => {
        state.campus = payload
    },

    SET_CAMPUS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_CAMPUS: (state, payload) => {
        state.campus.push(payload)
    },

    UPDATE_CAMPUS: (state, payload) => {
        state.campus = state.campus.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_CAMPUS: (state, payload) => {
        state.campus = state.campus.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_CAMPUS: async ({ commit, state }, { filter, campusEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await CampusService.get({ filter, campusEstado, ...pagination })
            if (status === 200) {
                commit("SET_CAMPUS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los campus, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_CAMPUS: async ({ commit }) => {
        try {
            let { data, status } = await CampusService.getAll()
            if (status === 200) {
                commit("SET_CAMPUS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_CAMPUS: async ({ commit }) => {
        try {
            let { data, status } = await CampusService.getAllRecords()
            if (status === 200) {
                commit("SET_CAMPUS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los campus, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_CAMPUS: async ({ commit }, payload) => {
        try {
            let { data, status } = await CampusService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_CAMPUS", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los detalles del campus, inténtelo nuevamente"
            })
        }
    },

    ADD_CAMPUS: async ({ commit }, payload) => {
        try {
            let { data, status } = await CampusService.post(payload)
            if (status === 201) {
                commit("ADD_CAMPUS", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El campus ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el campus, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_CAMPUS: async ({ commit }, payload) => {
        try {
            let { data, status } = await CampusService.put(payload)
            if (status === 200) {
                commit("UPDATE_CAMPUS", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El campus ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el campus, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_CAMPUS: async ({ commit }, payload) => {
        try {
            let { status, data } = await CampusService.delete(payload)
            if (status === 204) {
                commit("DELETE_CAMPUS", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El campus ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_CAMPUS", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El campus ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el campus, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
